import { render, staticRenderFns } from "./IndexContent4.vue?vue&type=template&id=3aeb5cc4&scoped=true"
import script from "./IndexContent4.vue?vue&type=script&lang=js"
export * from "./IndexContent4.vue?vue&type=script&lang=js"
import style0 from "./IndexContent4.vue?vue&type=style&index=0&id=3aeb5cc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeb5cc4",
  null
  
)

export default component.exports